import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import classNames from "classnames";
import { Icon, IconButton, Snackbar, SnackbarContent, makeStyles, RaiseColors } from "components/mui";
import React from "react";
import { IconConstants } from "componentLibrary";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function GlobalSnackbar(_ref) {
  var message = _ref.message,
    onClose = _ref.onClose,
    variant = _ref.variant;
  return /*#__PURE__*/_jsx(Snackbar, {
    anchorOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    open: Boolean(message),
    onClose: onClose,
    autoHideDuration: 3000,
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(StyledSnackbarMessage, {
        message: message,
        onClose: onClose,
        variant: variant
      })
    })
  });
}
var styles = function styles() {
  return {
    success: _defineProperty({
      backgroundColor: RaiseColors.watercourse200,
      borderColor: RaiseColors.watercourse900,
      color: RaiseColors.watercourse1500
    }, "& .MuiSnackbarContent-root", {
      color: RaiseColors.watercourse1500
    }),
    error: {
      backgroundColor: RaiseColors.destructive100,
      borderColor: RaiseColors.destructive500,
      color: RaiseColors.destructive500
    },
    "default": {
      backgroundColor: RaiseColors.science200,
      borderColor: RaiseColors.science900,
      color: RaiseColors.science1500
    },
    icon: {
      fontSize: 20
    },
    closeIcon: {
      fontSize: 20
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: 8
    },
    message: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: 0
    },
    root: {
      borderRadius: "8px"
    }
  };
};
var useStyles = makeStyles(styles);
var variantIcon = {
  success: "fa-solid fa-circle-check",
  error: "far fa-exclamation-circle"
};
var StyledSnackbarMessage = function SnackbarMessage(_ref2) {
  var className = _ref2.className,
    message = _ref2.message,
    onClose = _ref2.onClose,
    variant = _ref2.variant;
  var classes = useStyles();
  var iconColor = variant === "success" ? RaiseColors.watercourse1500 : RaiseColors.destructive500;
  return /*#__PURE__*/_jsx(SnackbarContent, {
    className: classNames(classes[variant], className),
    classes: {
      root: classes.root,
      message: classes.message,
      action: classes.action
    },
    "aria-describedby": "client-snackbar",
    message: /*#__PURE__*/_jsxs("span", {
      id: "client-snackbar",
      className: classes.message,
      children: [/*#__PURE__*/_jsx(Icon, {
        className: classNames(classes.icon, classes.iconVariant, variantIcon[variant]),
        color: iconColor
      }), message, /*#__PURE__*/_jsx(IconButton, {
        "aria-label": "Close",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(Icon, {
          className: IconConstants.X,
          fontSize: 16,
          color: iconColor
        })
      }, "close")]
    })
  });
};